const Leaderboard = ({ topFive, loaded, username }) => {
  return (
    <section id="leaderboard">
      <div className="py-3 text-center">
        <h2 className="mb-3">Leaderboard </h2>
      </div>

      <table className="table table-striped table-hover">
        <thead className="thead-dark">
          <tr>
            <th scope="col">Name</th>
            <th scope="col">Score</th>
          </tr>
        </thead>
        <tbody>
          {!loaded && (
            <tr>
              <td colSpan="2">Loading...</td>
            </tr>
          )}
          {!topFive && loaded && (
            <tr>
              <td colSpan="2">No users found</td>
            </tr>
          )}
          {topFive &&
            topFive.map((item, i) => (
              <tr
                key={i}
                className={
                  username === item.username
                    ? "font-weight-bold table-success"
                    : null
                }
              >
                <td>{item.username}</td>
                <td>{item.score}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </section>
  )
}

export default Leaderboard
